import { Link, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import FixWasteTable from "../components/Report/Details/FixWasteTable";
import { COMPACT_QUERY } from "../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

export default function FixWastePage() {
  const { reportId, reportCode, version } = useParams<{
    reportId: string;
    checkInId: string;
    reportCode: string;
    version: string;
  }>();

  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Link to="/report/sale" style={{ textDecoration: "none", color: "inherit" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            รายงาน
          </Typography>
        </Link>
        <Typography variant="body1" sx={{ mx: 1 }}>
          /
        </Typography>
        <Link
          to={`/report/sale/details/${reportId}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {reportCode}
          </Typography>
        </Link>
        <Typography variant="body1" sx={{ mx: 1 }}>
          /
        </Typography>
        <Typography variant="body1" color="primary">
          แก้ไขยอดของเสีย
        </Typography>
      </Box>
      <Paper sx={{ marginBottom: "24px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: "16px",
            paddingBottom: "16px",
            borderBottom: (theme) => `1px solid ${theme.palette.draft.main}`,
            [compact]: { marginBottom: "12px", paddingBottom: "12px" },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Link
              to={`/report/sale/details/${reportId}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <ArrowBackIosNewIcon />
            </Link>
            <Box
              sx={{
                marginLeft: "6px",
                position: "relative",
                bottom: "5px",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 500 }}>
                แก้ไขยอดของเสีย
              </Typography>
            </Box>
          </Box>
        </Box>
        <FixWasteTable version={version} />
      </Paper>
    </Box>
  );
}
